export default {"src":"/_next/static/media/placeholder.1d3d022f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};